import { KYMW9001Model } from '../kymw9001.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 権限セット追加用メソッド
 *
 * @export API通信成功時の処理
 * @class RegistAuthoritySetService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistAuthoritySetService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9001Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistAuthoritySetService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        AuthoritySet: {
          condition: {
            AuthoritySetName: this.vo.authoritySetName,
            AuthoritySetExplanation: this.vo.authoritySetExplanation,
            AdminDiv: this.vo.adminDiv,
          },
          combination: this.vo.funcAuthorityList.map(regist =>{
            return{
              condition: {
                FuncID: regist.FuncID,
                EnableMode: regist.EnableMode
             }
           }
         })
        }
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9001Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof RegistAuthoritySetService
   */
  execute(model: KYMW9001Model, vo: any, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registAuthoritySet', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistAuthoritySetService
   */
  success(data: any) {
    this.model.kymw9001Component.refleshParent(data);
  }

}
